var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-img',{staticClass:"dashboardLogo",attrs:{"aspect-ratio":227/150,"max-width":"50%","src":"/static/logo.svg"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }